import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { langPath } from '../../data/ladies';
import LegalModal from '../LegalModal/LegalModal';
import './Footer.css';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [modal, setModal] = useState(null);

  return (
    <>
      <footer id="contact" className="footer">
        <div className="footer__top">
          <div className="container footer__top-inner">

            {/* Brand */}
            <div className="footer__brand">
              <span className="footer__brand-name">OCEAN NOIR</span>
              <div className="footer__brand-line" />
              <p className="footer__tagline">{t('footer.tagline')}</p>
            </div>

            {/* Visit */}
            <div className="footer__contact">
              <p className="footer__contact-title">{t('footer.visitTitle')}</p>
              <a
                href="https://maps.google.com/?q=578+Harris+Street,+Ultimo+NSW"
                target="_blank"
                rel="noreferrer"
                className="footer__contact-row"
              >
                <span className="footer__contact-icon">📍</span>
                <span>
                  {t('footer.address')}
                  <em>{t('footer.hours')}</em>
                </span>
              </a>
              <p className="footer__visit-note">{t('footer.parkingNote')}</p>
              <p className="footer__visit-note">{t('footer.entranceNote')}</p>
            </div>

            {/* Contact */}
            <div className="footer__contact">
              <p className="footer__contact-title">{t('footer.contactTitle')}</p>
              <a href="mailto:oceannoir580@gmail.com" className="footer__contact-row">
                <span className="footer__contact-icon">✉</span>
                <span>{t('footer.email')}</span>
              </a>
              <a href="https://line.me/ti/p/@347chmhh" target="_blank" rel="noreferrer" className="footer__contact-row">
                <span className="footer__contact-icon">💬</span>
                <span>
                  {t('footer.line')}
                  <em>{t('footer.lineLabel')}</em>
                </span>
              </a>
              <div className="footer__contact-row">
                <span className="footer__contact-icon">💬</span>
                <span>
                  {t('footer.kakao')}
                  <em>{t('footer.kakaoLabel')}</em>
                </span>
              </div>
              <a href="tel:+61426945499" className="footer__contact-row">
                <span className="footer__contact-icon">✆</span>
                <span>
                  {t('footer.phone1')}
                  <em>{t('footer.phone1Label')}</em>
                </span>
              </a>
              <a href="tel:+61433132618" className="footer__contact-row">
                <span className="footer__contact-icon">✆</span>
                <span>
                  {t('footer.phone2')}
                  <em>{t('footer.phone2Label')}</em>
                </span>
              </a>
              <p className="footer__visit-note">
                <em>{t('footer.moreChannelsLabel')}</em> {t('footer.moreChannelsNote')}
              </p>
            </div>

            {/* Social */}
            <div className="footer__social">
              <p className="footer__contact-title">{t('footer.socialTitle')}</p>
              <div className="footer__social-row">
                <span className="footer__social-link">Instagram</span>
                <span className="footer__social-link">Facebook</span>
                <span className="footer__social-link">RedNote</span>
                <span className="footer__social-link">TikTok</span>
                <span className="footer__social-link">Reddit</span>
              </div>
            </div>

            {/* Links */}
            <nav className="footer__links">
              <Link to={langPath('/join-us', i18n.language)} className="footer__link">{t('footer.links.joinUs')}</Link>
              <button className="footer__link footer__link--btn" onClick={() => setModal('privacy')}>
                {t('footer.links.privacy')}
              </button>
              <button className="footer__link footer__link--btn" onClick={() => setModal('terms')}>
                {t('footer.links.terms')}
              </button>
            </nav>

          </div>
        </div>

        <div className="footer__bottom">
          <div className="container footer__bottom-inner">
            <p className="footer__rights">{t('footer.rights')}</p>
            <p className="footer__legal">{t('footer.legal')}</p>
          </div>
        </div>
      </footer>

      {modal && <LegalModal type={modal} onClose={() => setModal(null)} />}
    </>
  );
};

export default Footer;
